@if (authStore.authReady()) {
  <router-outlet />
} @else {
  <div class="flex h-full w-full items-center justify-center">
    <xemex-spinner size="lg" />
  </div>
}
